import * as React from 'react';
type Props = {
  className?: string;
};
export function SpiceMild({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Spice mild"
      className={className}
    >
      <path
        d="M30.2173 14.5767C30.8811 13.7684 31.6233 12.7178 32.2928 11.4129C33.4255 9.20911 33.898 7.16122 34.1114 5.71429M20.9958 16.4592C22.8149 17.0766 25.6866 18.3382 28.2357 20.9399C29.1508 21.8743 29.8574 22.8109 30.4016 23.6605M28.3893 13.6149C35.8451 16.56 29.1025 27.0562 25.447 30.0906C22.165 32.8149 18.2432 34.2011 14.0784 34.0177C12.9728 33.9703 6.34368 33.3476 6.42941 31.4049C6.4479 30.9754 7.59224 30.9957 9.79483 29.8136C14.3868 27.3463 15.4212 23.8578 18.1601 19.7834C20.1839 16.7724 24.341 12.0162 28.3893 13.6149Z"
        stroke="currentColor"
      />
    </svg>
  );
}
